import { createSelector, createSelectorFactory, defaultMemoize } from '@ngrx/store';

import { UserSelectors } from '@core/account-data';
import type { ShortInterviewResultRequest } from '@core/interview-result-request-types';
import { InterviewTemplateSelectors } from '@core/interview-templates-data';
import { InterviewTemplate } from '@core/interview-templates-types';
import { createEntityCollectionStore, memoizeSelector } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<
  ShortInterviewResultRequest<InterviewTemplate>
>()('InterviewScheduleResultRequestsCollection', {
  references: makeRef => [
    makeRef('adminId', 'admin', id => createSelector(UserSelectors.byId(id!), state => state!)),
    makeRef('interviewTemplateId', 'interviewTemplate', id =>
      createSelector(InterviewTemplateSelectors.byId(id!), state => state!),
    ),
  ],
  customActions: adapter => ({
    references: (state, payload: Array<ShortInterviewResultRequest<InterviewTemplate>>) =>
      adapter.updateOrCreateMany(state, payload),
  }),
});

const InterviewScheduleResultRequestsCollectionSelectors = {
  ...selectors,
  byIds: memoizeSelector((interviewScheduleResultRequestsIds: number[]) =>
    createSelectorFactory(defaultMemoize)(
      ...interviewScheduleResultRequestsIds.map(interviewScheduleResultRequestsIds =>
        selectors.byIdWithReferences(interviewScheduleResultRequestsIds),
      ),
      (...result: Array<ShortInterviewResultRequest<InterviewTemplate>>) => result,
    ),
  ),
};

export {
  actions as InterviewScheduleResultRequestsCollectionActions,
  InterviewScheduleResultRequestsCollectionSelectors,
  reducer as InterviewScheduleResultRequestsCollectionReducer,
  namespace as InterviewScheduleResultRequestsCollectionNamespace,
};
